import { useUserContext } from "../../../components/contexts/useUserContext"
import {Container, ProfileCard} from "../../ClientProfile/styles.js"
import UserPlaceholder from '../../../assets/user-placeholder.png'
import Button from '../../../components/Button'
import { Link } from "react-router-dom"
import { photo } from "../../../../src/services/photo"

function RetailerProfile() {
    const { user } = useUserContext()

    return (
        <>        
        <Container>
            <div className='title'>
                <h1>Meu perfil de Revendedor</h1>
                <h2>Olá, <span>{user? user.name:''}!</span> </h2>
            </div>
            <ProfileCard>
                <div className='client-info'>
                    <div className='profile-pic'>
                        <img alt="Foto de Perfil" src={user.client_image_url? `${photo.defaults.baseURL + user.client_image_url}`: UserPlaceholder} />
                    </div>
                </div>

                <p className='sub-title'>Informações Pessoais</p>
                { user.person_type === 'individual' ?
                    <div className="account">
                        <div className='client-account'>
                            <p>Nome</p>
                            <span>{user.name}</span>
                        </div>
                        <div className='client-account'>
                            <p>E-mail</p>
                            <span>{user.email}</span>
                        </div>

                        <div className='client-account'>
                            <p>CPF</p>
                            <span>{user.cpf}</span>
                        </div>
                        <div className='client-account'>
                            <p>RG</p>
                            <span>{user.rg}</span>
                        </div>
                    </div>
                : 
                    <div className="account">
                        <div className='client-account'>
                            <p>CNPJ</p>
                            <span>{user.cnpj}</span>
                        </div>
                        <div className='client-account'>
                            <p>Contribuição ICMS</p>
                            <span>{user.icms_contribution}</span>
                        </div>

                        <div className='client-account'>
                            <p>Razão Social</p>
                            <span>{user.social_name}</span>
                        </div>
                        <div className='client-account'>
                            <p>Nome Fantasia</p>
                            <span>{user.fantasy_name}</span>
                        </div>

                        <div className='client-account'>
                            <p>Inscrição Estadual</p>
                            <span>{user.state_registration}</span>
                        </div>
                        <div className='client-account'>
                            <p>Inscrição Municipal</p>
                            <span>{user.municipal_registration}</span>
                        </div>
                    </div>
                }
                
                <p className='sub-title'>Informações Bancárias</p>
                <div className="account">
                    <div className='client-account'>
                        <p>Tipo de conta</p>
                        <span>{user.account_type}</span>
                    </div>
                    <div className='client-account'>
                        <p>Banco</p>
                        <span>{user.bank}</span>
                    </div>

                    <div className='client-account'>
                        <p>Número da agência</p>
                        <span>{user.branch_number}</span>
                    </div>
                    <div className='client-account'>
                        <p>Código da agência</p>
                        <span>{user.branch_check_digit}</span>
                    </div>

                    <div className='client-account'>
                        <p>Número da conta</p>
                        <span>{user.account_number}</span>
                    </div>
                    <div className='client-account'>
                        <p>Dígito verificador</p>
                        <span>{user.account_check_digit}</span>
                    </div>
                </div>

                <p className='sub-title'>Endereço</p>
                <div className="account">
                    <div className='client-account'>
                        <p>DDD</p>
                        <span>{user.ddd}</span>
                    </div>
                    <div className='client-account'>
                        <p>Telefone</p>
                        <span>{user.phone}</span>
                    </div>

                    <div className='client-account'>
                        <p>Cidade</p>
                        <span>{user.city}</span>
                    </div>
                    <div className='client-account'>
                        <p>Estado</p>
                        <span>{user.state}</span>
                    </div>

                    <div className='client-account'>
                        <p>Bairro</p>
                        <span>{user.neighborhood}</span>
                    </div>
                    <div className='client-account'>
                        <p>Rua</p>
                        <span>{user.street}</span>
                    </div>
                </div>

                <div className='custom-button' style={{marginTop: '3rem'}}>
                    <Link>
                        <Button format='profile' type='submit' disabled>Editar perfil</Button>
                    </Link>
                </div>
            </ProfileCard>  
        </Container>
        </>
    )
}

export default RetailerProfile